export default `
  :root {
      /* # Color Palette */
      --wuk-primary-color-900: #C18801;
      --wuk-primary-color-800: #D09401;
      --wuk-primary-color-700: #E5A301;
      --wuk-primary-color-600: #FECB4D;
      --wuk-primary-color-500: #FED267;
      --wuk-primary-color-400: #FFE199;
      --wuk-primary-color-300: #FFE8B2;
      --wuk-primary-color-200: #FFF0CC;
      --wuk-primary-color-100: #FFF5DB;
      --wuk-primary-color-50:  #FFF8E6;

      --wuk-secondary-color-900: #293960;
      --wuk-secondary-color-800: #25426A;
      --wuk-secondary-color-700: #365D95;
      --wuk-secondary-color-600: #4779BF;
      --wuk-secondary-color-500: #5993EA;
      --wuk-secondary-color-400: #83BEEF;
      --wuk-secondary-color-300: #B5D8FF;
      --wuk-secondary-color-200: #CDDFF8;
      --wuk-secondary-color-100: #DEEAFB;
      --wuk-secondary-color-50:  #EEF4FD;

      --wuk-warning-color-800: #D06401;
      --wuk-warning-color-600: #FEA34D;
      --wuk-warning-color-500: #FEB067;
      --wuk-warning-color-200: #FFEDDB;
      --wuk-warning-color-100: #FFF2E6;

      --wuk-neutral-color-400: #E6DCD4;
      --wuk-neutral-color-300: #EFEAE6;
      --wuk-neutral-color-200: #F7F4F2;

      --wuk-grey-color-900: #1F222C;

      /* # Buttons */
      --wuk-button-theme-primary-color: var(--wuk-grey-color-900);
      --wuk-button-theme-white-hover-color: var(--wuk-primary-color-700);
      --wuk-button-theme-white-active-color: var(--wuk-primary-color-700);
      --wuk-button-theme-transparent-hover-color: var(--wuk-primary-color-700);
      --wuk-button-theme-transparent-active-background-color: var(--wuk-neutral-color-400);
      --wuk-button-theme-transparent-active-color: var(--wuk-primary-color-700);
      --wuk-button-theme-text-hover-color: var(--wuk-primary-color-700);

      /* # Inputs */
      --wuk-input-default-text-color-wuk: var(--wuk-grey-color-900);

      /* # Normal Checkbox */
      --wuk-toggle-input-hover-text-color: var(--wuk-grey-color-900);
      --wuk-toggle-input-active-text-color: var(--wuk-grey-color-900);
      --wuk-toggle-input-checked-text-color-wuk: var(--wuk-grey-color-900);
      --wuk-toggle-input-active-color: var(--wuk-grey-color-900);
      --wuk-toggle-input-icon-background-color: var(--wuk-primary-color-200);

      /* Tags */
      --wuk-tag-blue-text-color: var(--wuk-primary-color-700);
      --wuk-tag-blue-text-hover-color: var(--wuk-primary-color-800);

      /* Badges */
      --wuk-badge-text-hover-color: var(--wuk-grey-color-900);
      --wuk-badge-text-active-color: var(--wuk-grey-color-900);

      /* Links */
      --wuk-link-theme-primary-text-color: var(--wuk-primary-color-700);
      --wuk-link-theme-primary-text-hover-color: var(--wuk-primary-color-800);
      --wuk-link-theme-secondary-text-hover-color: var(--wuk-primary-color-800);

     /* Breadcrumbs */
     --wuk-breadcrumb-text-exact-active-color: var(--wuk-primary-color-700);
     --wuk-breadcrumb-text-hover-color: var(--wuk-primary-color-700);
     --wuk-breadcrumb-text-active-color: var(--wuk-primary-color-800);

     /* Tabs */
     --wuk-tab-text-hover-color: var(--wuk-primary-color-700);
     --wuk-tab-text-active-color: var(--wuk-primary-color-700);

     /* Notifications (Toast)*/
     --wuk-notification-info-background-color: var(--wuk-primary-color-200);
     --wuk-notification-warning-background-color: var(--wuk-warning-color-500);
     --wuk-notification-neutral-background-color: var(--wuk-neutral-color-200);
  }
`;
